export function positionVueSelectDropdown(dropdownList, component, { width, top, left }) {
    dropdownList.style.top = top;
    dropdownList.style.left = left;
    dropdownList.style.width = width;
    dropdownList.style.zIndex = '1060';
}

